import React from 'react';
import HeaderTop from '../common/header/HeaderTop';
import HeaderBottomTwo from '../common/header/HeaderBottomTwo';
import HeroStyleTwo from '../components/hero/HeroStyleTwo';
import SimpleCta from '../components/cta/SimpleCta';
import HomeTwoFeature from '../components/home2/HomeTwoFeature';
import HomeTwoAbout from '../components/home2/HomeTwoAbout';
import FunFact from '../components/fun-fact/FunFact';
import WhyChoseUsTwo from '../components/why-choose-us/WhyChoseUsTwo';
import ServiceStyleTwo from '../components/services/ServiceStyleTwo';
import TestimonialStyleTwo from '../components/testimonial/TestimonialStyleTwo';
import HomeTwoProject from '../components/home2/HomeTwoProject';
import CtaOne from '../components/cta/CtaOne';
import TeamStyleOne from '../components/team/TeamStyleOne';
import QueryFormStyleOne from '../components/query-form/QueryFormStyleOne';
import BlogStyleTwo from '../components/blog/BlogStyleTwo';
import Subscribe from '../components/subscribe/Subscribe';
import FooterTwo from '../common/footer/FooterTwo';

const HomeTwo = () => {
    return (
        <>
            <HeaderTop />
            <HeaderBottomTwo />
            <HeroStyleTwo />
            <SimpleCta />
            <HomeTwoFeature />
            <HomeTwoAbout />
            <FunFact />
            <WhyChoseUsTwo />
            <ServiceStyleTwo />
            <TestimonialStyleTwo />
            <HomeTwoProject />
            <CtaOne />
            <TeamStyleOne />
            <QueryFormStyleOne />
            <BlogStyleTwo />
            <Subscribe />
            <FooterTwo />

        </>
    )
}

export default HomeTwo;